import axios from 'axios';
import { functionExist } from 'cgil-html-utils';
import { DEFAULT_BASE_SERVER_URL, getLog } from '../config';
import { getLocalJwtTokenAuth } from './Login';

const log = getLog('Chantier', 4, 1);

let instance = null;
/*  Singleton to retrieve chantier
 */
class Chantier {
  constructor() {
    if (!instance) {
      instance = this;
    }
    // to test whether we have singleton or not and store how old is data
    this.time = new Date();
    this.data = [];
    this.isReady = false;
    return instance;
  }

  getList(callbackLoaded) {
    log.t('## IN getList');
    axios.defaults.headers.common.Authorization = getLocalJwtTokenAuth();
    axios.get(`${DEFAULT_BASE_SERVER_URL}/chantiers`, { timeout: 22000 }) // 12 sec
      .then((resp) => {
        this.lastError = null;
        this.lastErrorMsg = null;
        log.t('## IN getList axios get success resp.data :', resp.data);
        this.isReady = true;
        if (functionExist(callbackLoaded)) {
          callbackLoaded(resp.data, 'SUCCESS');
        }
      })
      .catch((err) => {
        this.isReady = false;
        log.e('## ERROR IN getList while retrieving data with axios.get ');
        if (err.response) {
          log.e(' -- The request was made, but the server responded with a status code > 2xx', err.response);
          this.lastErrorMsg = ` getList : La requete http a recu en retour un code status=${err.response.status} >2xx ! `;
          this.lastError = err.response;
        } else if (err.request) {
          log.e(' -- The request was made, but no response was received from the server', err.request);
          this.lastErrorMsg = ' getList : La requete http n\'a pas reçu de reponse du serveur ! ';
          this.lastError = err.request;
        } else {
          log.e(' -- Something happened in setting up the request that triggered an Error', err.message);
          this.lastErrorMsg = ' getList : La requete http est erronée et n\'a pas pu se faire! ';
          this.lastError = err.message;
        }
        if (functionExist(callbackLoaded)) {
          callbackLoaded(null, '## ERROR IN getList while retrieving data with axios.get');
        }
      });
  }

  newChantier(data, callbackLoaded) {
    const method = 'newChantier';
    log.t(`## IN ${method}`);
    axios.defaults.headers.common.Authorization = getLocalJwtTokenAuth();
    axios.post(`${DEFAULT_BASE_SERVER_URL}/chantier/new`, data)
      .then((resp) => {
        this.lastError = null;
        this.lastErrorMsg = null;
        log.t('## IN newChantier axios get success resp.data :', resp.data);
        this.isReady = true;
        if (functionExist(callbackLoaded)) {
          callbackLoaded(resp.data, 'SUCCESS');
        }
      })
      .catch((err) => {
        this.isReady = false;
        let errMessage = `## ERREUR RESEAU DANS ${method} PENDANT UN APPEL DISTANT axios.post`;
        log.e(errMessage);
        if (err.response) {
          const errResponse = err.response;
          log.e(' -- The request was made, but the server responded with a status code > 2xx', errResponse, errResponse.data);
          this.lastErrorMsg = ` ${method} : La requete http a recu en retour un code status=${errResponse.status} >200 ! `;
          errMessage += `${this.lastErrorMsg} <br> Message serveur : ${errResponse.data.error.reason}`;
          this.lastError = err.response;
        } else if (err.request) {
          log.e(' -- The request was made, but no response was received from the server', err.request);
          this.lastErrorMsg = ` ${method} : La requete http n'a pas reçu de reponse du serveur ! `;
          errMessage += `${this.lastErrorMsg} <br> Message serveur : ${err.request}`;
          this.lastError = err.request;
        } else {
          log.e(' -- Something happened in setting up the request that triggered an Error', err.message);
          this.lastErrorMsg = ` ${method} : La requete http est erronée et n'a pas pu se faire! `;
          errMessage += `${this.lastErrorMsg} <br> Message serveur : ${err.message}`;
          this.lastError = err.message;
        }
        if (functionExist(callbackLoaded)) {
          callbackLoaded(
            null,
            ` <br>${errMessage}`,
          );
        }
      });
  }

  saveChantier(id, data, callbackLoaded) {
    const method = 'saveChantier';
    log.t(`## IN ${method}`);
    axios.defaults.headers.common.Authorization = getLocalJwtTokenAuth();
    axios.post(`${DEFAULT_BASE_SERVER_URL}/chantier/${id}`, data)
      .then((resp) => {
        this.lastError = null;
        this.lastErrorMsg = null;
        log.t(`## IN ${method} id:${id} axios post success resp.data :`, resp.data);
        this.isReady = true;
        if (functionExist(callbackLoaded)) {
          callbackLoaded(resp.data, 'SUCCESS');
        }
      })
      .catch((err) => {
        this.isReady = false;
        let errMessage = `## ERREUR DANS ${method} id:${id} PENDANT UN APPEL DISTANT axios.post`;
        log.e(errMessage);
        if (err.response) {
          const errResponse = err.response;
          log.e(' -- The request was made, but the server responded with a status code > 2xx', errResponse, errResponse.data);
          this.lastErrorMsg = ` ${method} : La requete http a recu en retour un code status=${errResponse.status} >200 ! `;
          errMessage += `${this.lastErrorMsg} <br> Message serveur : ${errResponse.data.error.reason}`;
          this.lastError = err.response;
        } else if (err.request) {
          log.e(' -- The request was made, but no response was received from the server', err.request);
          this.lastErrorMsg = ` ${method} : La requete http n'a pas reçu de reponse du serveur ! `;
          errMessage += `${this.lastErrorMsg} <br> Message serveur : ${err.request}`;
          this.lastError = err.request;
        } else {
          log.e(' -- Something happened in setting up the request that triggered an Error', err.message);
          this.lastErrorMsg = ` ${method} : La requete http est erronée et n'a pas pu se faire! `;
          errMessage += `${this.lastErrorMsg} <br> Message serveur : ${err.message}`;
          this.lastError = err.message;
        }
        if (functionExist(callbackLoaded)) {
          callbackLoaded(
            null,
            ` <br>${errMessage}`,
          );
        }
      });
  }

  deleteChantier(id, callbackLoaded) {
    const method = 'deleteChantier';
    log.t(`## IN ${method}`);
    axios.defaults.headers.common.Authorization = getLocalJwtTokenAuth();
    axios.delete(`${DEFAULT_BASE_SERVER_URL}/chantier/${id}`)
      .then((resp) => {
        this.lastError = null;
        this.lastErrorMsg = null;
        log.t(`## IN ${method} id:${id} axios post success resp.data :`, resp.data);
        this.isReady = true;
        if (functionExist(callbackLoaded)) {
          callbackLoaded(resp.data, 'SUCCESS');
        }
      })
      .catch((err) => {
        this.isReady = false;
        let errMessage = `## ERREUR DANS ${method} id:${id} PENDANT UN APPEL DISTANT axios.delete`;
        log.e(errMessage);
        if (err.response) {
          const errResponse = err.response;
          log.e(' -- The request was made, but the server responded with a status code > 2xx', errResponse, errResponse.data);
          this.lastErrorMsg = ` ${method} : La requete http a recu en retour un code status=${errResponse.status} >200 ! `;
          errMessage += `${this.lastErrorMsg} <br> Message serveur : ${errResponse.data.error.reason}`;
          this.lastError = err.response;
        } else if (err.request) {
          log.e(' -- The request was made, but no response was received from the server', err.request);
          this.lastErrorMsg = ` ${method} : La requete http n'a pas reçu de reponse du serveur ! `;
          errMessage += `${this.lastErrorMsg} <br> Message serveur : ${err.request}`;
          this.lastError = err.request;
        } else {
          log.e(' -- Something happened in setting up the request that triggered an Error', err.message);
          this.lastErrorMsg = ` ${method} : La requete http est erronée et n'a pas pu se faire! `;
          errMessage += `${this.lastErrorMsg} <br> Message serveur : ${err.message}`;
          this.lastError = err.message;
        }
        if (functionExist(callbackLoaded)) {
          callbackLoaded(
            null,
            ` <br>${errMessage}`,
          );
        }
      });
  }

  getParticipeChantier(callbackLoaded) {
    const method = 'getParticipeChantier';
    log.t(`## IN ${method}`);
    axios.defaults.headers.common.Authorization = getLocalJwtTokenAuth();
    axios.get(`${DEFAULT_BASE_SERVER_URL}/chantier/registered`, { timeout: 12000 }) // 12 sec
      .then((resp) => {
        this.lastError = null;
        this.lastErrorMsg = null;
        log.t(`## IN ${method} axios get success resp.data :`, resp.data);
        this.isReady = true;
        if (functionExist(callbackLoaded)) {
          callbackLoaded(resp.data, 'SUCCESS');
        }
      })
      .catch((err) => {
        this.isReady = false;
        let errMessage = `## ERREUR DANS ${method} PENDANT UN APPEL DISTANT axios.get`;
        log.e(errMessage);
        if (err.response) {
          const errResponse = err.response;
          log.e(' -- The request was made, but the server responded with a status code > 2xx', errResponse, errResponse.data);
          this.lastErrorMsg = ` ${method} : La requete http a recu en retour un code status=${errResponse.status} >200 ! `;
          errMessage += `${this.lastErrorMsg} <br> Message serveur : ${errResponse.data.error.reason}`;
          this.lastError = err.response;
        } else if (err.request) {
          log.e(' -- The request was made, but no response was received from the server', err.request);
          this.lastErrorMsg = ` ${method} : La requete http n'a pas reçu de reponse du serveur ! `;
          errMessage += `${this.lastErrorMsg} <br> Message serveur : ${err.request}`;
          this.lastError = err.request;
        } else {
          log.e(' -- Something happened in setting up the request that triggered an Error', err.message);
          this.lastErrorMsg = ` ${method} : La requete http est erronée et n'a pas pu se faire! `;
          errMessage += `${this.lastErrorMsg} <br> Message serveur : ${err.message}`;
          this.lastError = err.message;
        }
        if (functionExist(callbackLoaded)) {
          callbackLoaded(
            null,
            ` <br>${errMessage}`,
          );
        }
      });
  }

  registerToChantier(id, data, callbackLoaded) {
    const method = 'registerChantier';
    log.t(`## IN ${method}`);
    axios.defaults.headers.common.Authorization = getLocalJwtTokenAuth();
    axios.post(`${DEFAULT_BASE_SERVER_URL}/chantier/register/${id}`, data)
      .then((resp) => {
        this.lastError = null;
        this.lastErrorMsg = null;
        log.t(`## IN ${method} id:${id} axios post success resp.data :`, resp.data);
        this.isReady = true;
        if (functionExist(callbackLoaded)) {
          callbackLoaded(resp.data, 'SUCCESS');
        }
      })
      .catch((err) => {
        this.isReady = false;
        let errMessage = `## ERREUR DANS ${method} id:${id} PENDANT UN APPEL DISTANT axios.post`;
        log.e(errMessage);
        if (err.response) {
          const errResponse = err.response;
          log.e(' -- The request was made, but the server responded with a status code > 2xx', errResponse, errResponse.data);
          this.lastErrorMsg = ` ${method} : La requete http a recu en retour un code status=${errResponse.status} >200 ! `;
          errMessage += `${this.lastErrorMsg} <br> Message serveur : ${errResponse.data.error.reason}`;
          this.lastError = err.response;
        } else if (err.request) {
          log.e(' -- The request was made, but no response was received from the server', err.request);
          this.lastErrorMsg = ` ${method} : La requete http n'a pas reçu de reponse du serveur ! `;
          errMessage += `${this.lastErrorMsg} <br> Message serveur : ${err.request}`;
          this.lastError = err.request;
        } else {
          log.e(' -- Something happened in setting up the request that triggered an Error', err.message);
          this.lastErrorMsg = ` ${method} : La requete http est erronée et n'a pas pu se faire! `;
          errMessage += `${this.lastErrorMsg} <br> Message serveur : ${err.message}`;
          this.lastError = err.message;
        }
        if (functionExist(callbackLoaded)) {
          callbackLoaded(
            null,
            ` <br>${errMessage}`,
          );
        }
      });
  }

  unregisterToChantier(id, data, callbackLoaded) {
    const method = 'unregisterChantier';
    log.t(`## IN ${method}`);
    axios.defaults.headers.common.Authorization = getLocalJwtTokenAuth();
    axios.post(`${DEFAULT_BASE_SERVER_URL}/chantier/unregister/${id}`, data)
      .then((resp) => {
        this.lastError = null;
        this.lastErrorMsg = null;
        log.t(`## IN ${method} id:${id} axios post success resp.data :`, resp.data);
        this.isReady = true;
        if (functionExist(callbackLoaded)) {
          callbackLoaded(resp.data, 'SUCCESS');
        }
      })
      .catch((err) => {
        this.isReady = false;
        let errMessage = `## ERREUR DANS ${method} id:${id} PENDANT UN APPEL DISTANT axios.post`;
        log.e(errMessage);
        if (err.response) {
          const errResponse = err.response;
          log.e(' -- The request was made, but the server responded with a status code > 2xx', errResponse, errResponse.data);
          this.lastErrorMsg = ` ${method} : La requete http a recu en retour un code status=${errResponse.status} >200 ! `;
          errMessage += `${this.lastErrorMsg} <br> Message serveur : ${errResponse.data.error.reason}`;
          this.lastError = err.response;
        } else if (err.request) {
          log.e(' -- The request was made, but no response was received from the server', err.request);
          this.lastErrorMsg = ` ${method} : La requete http n'a pas reçu de reponse du serveur ! `;
          errMessage += `${this.lastErrorMsg} <br> Message serveur : ${err.request}`;
          this.lastError = err.request;
        } else {
          log.e(' -- Something happened in setting up the request that triggered an Error', err.message);
          this.lastErrorMsg = ` ${method} : La requete http est erronée et n'a pas pu se faire! `;
          errMessage += `${this.lastErrorMsg} <br> Message serveur : ${err.message}`;
          this.lastError = err.message;
        }
        if (functionExist(callbackLoaded)) {
          callbackLoaded(
            null,
            ` <br>${errMessage}`,
          );
        }
      });
  }
}
const chantier = new Chantier();
export default chantier;
